import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";

const ReferralModal = ({ isOpen, toggle, referralCode, referralURL }) => {
  const [copied, setCopied] = useState("");

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(text);
      setTimeout(() => setCopied(""), 2000);
    });
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Referral Details</ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <label className="form-label"><strong>Referral Code</strong></label>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              value={referralCode}
              readOnly
            />
            <Button
              color="secondary"
              onClick={() => handleCopy(referralCode)}
            >
              📋
            </Button>
          </div>
          {copied === referralCode && (
            <small className="text-success">Copied!</small>
          )}
        </div>

        <div className="mb-3">
          <label className="form-label"><strong>Referral URL</strong></label>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              value={referralURL}
              readOnly
            />
            <Button
              color="secondary"
              onClick={() => handleCopy(referralURL)}
            >
              📋
            </Button>
          </div>
          {copied === referralURL && (
            <small className="text-success">Copied!</small>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ReferralModal;
